<template>
  <div v-if="dataAvailableProducts.length > 1" class="form-group">
    <label :for="productIdInputId">
      {{ trans("evaluation.tableColumnProduct") }}
    </label>
    <select2
      :id="productIdInputId"
      name="productId"
      :options="dataAvailableProducts"
      :placeholder="trans('forms.chooseProductPlaceholderOptional')"
    />
  </div>
</template>
<script setup>
import { v4 as uuidV4 } from "uuid";

const productIdInputId = uuidV4();

defineProps({
  dataAvailableProducts: {
    type: /** @type {Array<{ id: number, text: string }>} */ Array,
    required: true,
  },
});
</script>
